/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import React from 'react';
import { IHosportsZendeskViewProps } from '../../../modules/hosports-zendesk/./hosports-zendesk';
import ZendeskWidget from './../../../baseComponents/zendesk-widget/./zendesk-widget';

class IHosportsZendeskView extends React.Component<IHosportsZendeskViewProps> {
  constructor(props: IHosportsZendeskViewProps) {
    super(props);

  }
   public render(): JSX.Element {
     let config = this.props.config;
     if(config){
       if(config.key){
         return <ZendeskWidget zendeskKey={config.key} />
       }
       return <span />
     } else{
       return <span />
     }
   }
 }

export default IHosportsZendeskView;
